<template>
  <v-sheet elevation="0" class="px-8 py-2">
    <v-row>
      <v-text-field
        ref="flow-name"
        :label="selectedFlow == -1 ? 'Name your flow' : 'Flow Name'"
        v-model="flowName"
        v-if="PreviewMode == false"
        class="py-1"
        dense
        required
        :rules="[rules.required]"
        persistent-hint
        hint="Make it memorable so you can reuse it with multiple tracking numbers"
        autofocus
        autocomplete="off"
        outlined
      ></v-text-field>
    </v-row>
    <div v-if="selectedFlow && !hideFlow">
      <v-row class="mt-12">
        <v-card outlined class="mx-auto py-2 px-8" width="250" elevation="1">
          <div class="mx-auto text-center">
            <v-icon>mdi-phone-incoming</v-icon> Incoming Call
          </div>
        </v-card>
      </v-row>
      <div v-for="flowItem in flowList" :key="'flow-item-' + flowItem.uid">
        <call-flow-greeting
          :order="flowList.findIndex(item => item.uid == flowItem.uid)"
          :PreviewMode="PreviewMode"
          :onRemove="onClickRemove"
          :flowList="flowList"
          :config="flowItem"
          :updateCallback="updateFlow"
          v-if="flowItem.type == 'greeting'"
        ></call-flow-greeting>
        <call-flow-forward
          :order="flowList.findIndex(item => item.uid == flowItem.uid)"
          :PreviewMode="PreviewMode"
          :onRemove="onClickRemove"
          :flowList="flowList"
          :config="flowItem"
          :updateCallback="updateFlow"
          :ForwardMulti="false"
          v-if="flowItem.type == 'forward'"
        ></call-flow-forward>
        <call-flow-forward
          :order="flowList.findIndex(item => item.uid == flowItem.uid)"
          :PreviewMode="PreviewMode"
          :onRemove="onClickRemove"
          :flowList="flowList"
          :config="flowItem"
          :updateCallback="updateFlow"
          :ForwardMulti="true"
          v-if="flowItem.type == 'multiring'"
        ></call-flow-forward>
        <call-flow-voicemail
          :order="flowList.findIndex(item => item.uid == flowItem.uid)"
          :PreviewMode="PreviewMode"
          :onRemove="onClickRemove"
          :flowList="flowList"
          :config="flowItem"
          :updateCallback="updateFlow"
          v-if="flowItem.type == 'voicemail'"
        ></call-flow-voicemail>
        <call-flow-i-v-r
          :FlowId="selectedFlow"
          :order="flowList.findIndex(item => item.uid == flowItem.uid)"
          :PreviewMode="PreviewMode"
          :onRemove="onClickRemove"
          :flowList="flowList"
          :config="flowItem"
          :updateCallback="updateFlow"
          v-if="flowItem.type == 'ivr'"
        ></call-flow-i-v-r>
        <call-flow-redirect
          :FlowId="selectedFlow"
          :order="flowList.findIndex(item => item.uid == flowItem.uid)"
          :PreviewMode="PreviewMode"
          :onRemove="onClickRemove"
          :flowList="flowList"
          :config="flowItem"
          :updateCallback="updateFlow"
          v-if="flowItem.type == 'redirect'"
        ></call-flow-redirect>
      </div>
      <call-flow-add-step
        :clickWhatNext="onClickWhatNext"
        v-if="PreviewMode != true"
      ></call-flow-add-step>
      <v-row class="">
        <div class="flow-line">
          <div class="pt-8 flow-line-inside">&nbsp;</div>
        </div>
        <v-card outlined class="mx-auto py-2 px-8" width="250" elevation="1">
          <div class="mx-auto text-center">
            <v-icon>mdi-phone-hangup</v-icon> Call Hung Up
          </div>
        </v-card>
      </v-row>
    </div>
    <div v-if="hideFlow">
      <v-icon>mdi-spinner</v-icon>
    </div>
  </v-sheet>
</template>

<script>
import ListItem from "../../../models/ListItem";
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";
import CallFlowAddStep from "./CallFlowAddStep";
import CallFlowGreeting from "./CallFlowGreeting";
import CallFlowForward from "./CallFlowForward";
import CallFlowVoicemail from "./CallFlowVoicemail";
import CallFlowIVR from "./CallFlowIVR";
import CallFlowRedirect from "./CallFlowRedirect";

export default {
  name: "CallFlowSetup",
  components: {
    CallFlowAddStep,
    CallFlowGreeting,
    CallFlowForward,
    CallFlowVoicemail,
    CallFlowIVR,
    CallFlowRedirect
  },
  directives: {
    mask
  },
  props: {
    PreviewMode: {
      type: Boolean,
      default: false
    },
    FlowId: {
      type: Number,
      required: false
    },
    Source: {
      type: String,
      required: true
    },
    CallTrackingNumber: {
      type: Object,
      required: false
    },
    CallTrackingCallback: {
      type: Function,
      required: false
    }
  },
  data: function() {
    return {
      dialog: false,
      editedIndex: -1,
      editedItem: new ListItem(),

      hideFlow: true,
      selectedFlow: null,
      flowName: null,
      flowUID: null,
      flowList: [],

      masks: MASKS,
      rules: VALIDATION_RULES
    };
  },
  created() {
    this.onStartup();
  },
  computed: {
    headers() {
      let headers = [
        { text: "Order", value: "rank", sortable: false },
        {
          text: "Name",
          align: "start",
          value: "name",
          sortable: false
        }
      ];
      if (["job_type"].includes(this.listType.code)) {
        headers.push({ text: "Color", value: "colorOnly", sortable: false });
      }
      if (["msg_template"].includes(this.listType.code)) {
        headers.push({ text: "Value", value: "value", sortable: false });
      }
      headers.push({ text: "Action", value: "actions", sortable: false });
      return headers;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    listType() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("id", this.listTypeId)
        .first();
      return listType;
    },
    callFlowType() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["call_flow"].includes(value))
        .first();
      return listType;
    },
    callFlows() {
      const type = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["call_flow"].includes(value))
        .first();
      // type.items.push({
      //   id: -1,
      //   name: " - New Call Flow - "
      // });
      return type;
    }
  },
  methods: {
    onStartup() {
      if (this.FlowId == null) {
        const newUUID = this.$uuidv4();
        this.flowUID = newUUID;
      } else {
        this.selectedFlow = this.FlowId;
      }
      if (this.selectedFlow > 0) {
        const currentFlow = JSON.parse(
          JSON.stringify(
            this.callFlows.items.filter(item => item.id == this.selectedFlow)[0]
          )
        );
        if (currentFlow.meta && currentFlow.meta.flow) {
          if (currentFlow.meta.flow) {
            this.flowList = currentFlow.meta.flow;
          }
          if (currentFlow.meta.uid) {
            this.flowUID = currentFlow.meta.uid;
          } else {
            const newUUID = this.$uuidv4();
            this.flowUID = newUUID;
          }
        }
        this.flowName = currentFlow.name;
      }
      this.hideFlow = false;
    },
    onClickWhatNext(type) {
      const newUUID = this.$uuidv4();
      if (this.flowList.length > 0) {
        this.flowList[this.flowList.length - 1].redirectTo = newUUID;
      }
      const nextFlowListOrder = this.flowList.length;
      this.flowList.push({
        type: type,
        order: nextFlowListOrder,
        uid: newUUID
      });
    },
    onClickRemove(uuid) {
      this.flowList = this.flowList.filter(item => item.uid != uuid);
    },
    updateFlow(order, config) {
      this.flowList.splice(order, 1, config);
    }
  }
  // ,
  // watch: {
  //   selectedFlow(newVal, oldVal) {
  //     if (oldVal != newVal) {
  //       this.onStartup();
  //     }
  //   }
  // }
};
</script>

<style scoped lang="stylus">
div.areaCode {
  max-width: 300px;
}
.flow-line {
  height: 3rem;
  width: 100%;
}
.flow-line-inside {
  height: 3rem;
  width: 50%;
  border-right: 1px solid #cccccc;
}
</style>
